import { useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { Spinner } from '@/components/ui/spinner';
import { useAuthStore } from '@/stores/auth-store';

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const status = useAuthStore((state) => state.status);
  const restore = useAuthStore((state) => state.restore);

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (status === 'signedOut') {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export const RequirePlatformManager = ({ children }: { children: ReactNode }) => {
  const user = useAuthStore((state) => state.user);
  if (
    user?.platformRole !== 'platform_admin' &&
    user?.platformRole !== 'platform_manager'
  ) {
    return <Navigate to="/sign-in" replace />;
  }
  return <>{children}</>;
};

export const RequirePlatformAdmin = ({ children }: { children: ReactNode }) => {
  const user = useAuthStore((state) => state.user);
  if (user?.platformRole !== 'platform_admin') {
    return <Navigate to="/churches" replace />;
  }
  return <>{children}</>;
};
